import { createFileRoute, Outlet, useRouterState } from "@tanstack/react-router";
import {
  SettingsScopeLine,
  settingsPageAt,
  useSettingsRemountKey,
} from "@/components/app/rails/settings-scope-line";

export const Route = createFileRoute("/_authenticated/_front-desk/sarah")({
  component: FrontDeskLayout,
});

/** The front desk's settings pages get the hub's scope line and remount here; its operations pages
 * do not. */
function FrontDeskLayout() {
  const pathname = useRouterState({ select: (state) => state.location.pathname });
  const remountKey = useSettingsRemountKey();
  if (!settingsPageAt(pathname)) return <Outlet />;
  return (
    <div>
      <SettingsScopeLine className="mb-3" />
      <div key={remountKey} className="space-y-6">
        <Outlet />
      </div>
    </div>
  );
}
